// extracted by mini-css-extract-plugin
export var numpadContainer = "_lw-1";
export var phoneButton = "_lw-0";